<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "job",
      key: "jobId",
      url: {
        get: "/admin/monitor/job",
        add: "/admin/monitor/job",
        edit: "/admin/monitor/job",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "任务名称",
          name: "jobName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "任务分组",
          name: "jobGroup",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            {
              value: "SYSTEM",
              name: "系统",
            },
            {
              value: "DEFAULT",
              name: "默认",
            },
          ],
        },
        {
          label: "调用方法",
          name: "invokeTarget",
          value: "",
          type: "input",
          width: "400px",
          desc: "Bean调用示例：ryTask.ryParams('ry'),Class类调用示例：com.ruoyi.quartz.task.RyTask.ryParams('ry'),参数说明：支持字符串，布尔类型，长整型，浮点型，整型",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "cron表达式",
          name: "cronExpression",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "错误策略",
          name: "misfirePolicy",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            {
              value: '1',
              name: "立即执行",
            },
            {
              value: '2',
              name: "执行一次",
            },
            {
              value: '3',
              name: "放弃执行",
            },
          ],
        },
        {
          label: "是否并发",
          name: "concurrent",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            {
              value: '0',
              name: "允许",
            },
            {
              value: '1',
              name: "禁止",
            },
          ],
        },
        { label: '状态', name: 'status', value: '0', type: 'switch', trueValue: '0', falseValue: '1' },
      ],
      forms: {},
    };
  },
  created() {},
  methods: {},
};
</script>
